


































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import moment from "moment";
import { STORE_KEY, store } from "./_store";
import ProductTypeForecastGroupForm from "./ProductTypeForecastGroupForm.vue";
import TitleBar from "@/components/Elements/TitleBar.vue";

@Component({
  components: { ProductTypeForecastGroupForm, TitleBar },
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "items",
      "days",
      "slots",
      "totals",
      "meta",
      "forecastGroup",
      "pendingOutputs",
      "savingOutputs"
    ])
  }
})
export default class ProductionForecastDaily extends Vue {
  loaded!: boolean;
  loading!: boolean;
  fatalError!: boolean;
  items!: any[];
  days!: any[];
  slots!: any[];
  totals!: any;
  meta!: any;
  forecastGroup!: string;
  pendingOutputs!: Record<string, any>;
  savingOutputs!: boolean;

  localFilter: any = {
    date: moment().toDate(),
    forecastGroup: "cheese"
  };

  get titleStack() {
    return ["Планирование производства"];
  }

  get dayColspan() {
    return 6 + (this.slots ? this.slots.length : 0);
  }

  get hasPendingOutputs() {
    return Object.keys(this.pendingOutputs || {}).length > 0;
  }

  created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  mounted() {
    this.syncFromRoute();
    if (!this.$route.query.date && !this.$route.query.dateFrom) {
      this.applyFilter();
    } else {
      this.load();
    }
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  @Watch("$route.query")
  onRouteQuery() {
    this.syncFromRoute();
    this.load();
  }

  syncFromRoute() {
    const q = this.$route.query;
    const dateStr = q.date || q.dateFrom;
    this.localFilter = {
      date: dateStr ? moment(String(dateStr)).toDate() : this.localFilter.date,
      forecastGroup: String(q.forecastGroup || this.localFilter.forecastGroup || "cheese")
    };
  }

  applyFilter() {
    const date = moment(this.localFilter.date).format("YYYY-MM-DD");
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.log("[FIX] ProductionForecastDaily applyFilter", {
        date,
        forecastGroup: this.localFilter.forecastGroup
      });
    }

    this.$router.replace({
      query: {
        date,
        forecastGroup: this.localFilter.forecastGroup
      }
    });
  }

  onDatePicked() {
    this.applyFilter();
  }

  shiftDay(offset: number) {
    this.localFilter.date = moment(this.localFilter.date).add(offset, "day").toDate();
    this.applyFilter();
  }

  load() {
    this.$store
      .dispatch(`${STORE_KEY}/loadData`, { ...this.localFilter })
      .catch((e: any) => this.showError(e));
  }

  toggleSticker(stickerId: any) {
    this.$store.dispatch(`${STORE_KEY}/toggleSticker`, stickerId);
  }

  expandAllStickers() {
    this.$store.dispatch(`${STORE_KEY}/expandAllStickers`);
  }

  collapseAllStickers() {
    this.$store.dispatch(`${STORE_KEY}/collapseAllStickers`);
  }

  openSettings() {
    this.$buefy.modal.open({
      parent: this,
      component: ProductTypeForecastGroupForm,
      hasModalCard: true,
      trapFocus: true,
      events: {
        saved: () => this.load()
      }
    });
  }

  exportXlsx() {
    this.$store.dispatch(`${STORE_KEY}/exportData`).then(() => {
      this.$buefy.toast.open({ message: "Экспорт готов", type: "is-success" });
    });
  }

  stickerKey(sticker: any) {
    return String(sticker.sticker_id || sticker.sticker_name || "none");
  }

  dayHeader(day: any) {
    return moment(day.date).format("dd DD.MM");
  }

  dayHeaderColClass(day: any, idx: number) {
    const classes = [...this.dayColClass(day, idx)];
    if (this.isAnchorDay(day)) {
      classes.push("is-anchor-day-header");
    }
    return classes;
  }

  isAnchorDay(day: any) {
    return (
      moment(day.date).format("YYYY-MM-DD") === moment(this.localFilter.date).format("YYYY-MM-DD")
    );
  }

  formatKgsHideZero(value: any): string {
    const n = Number(value);
    if (!Number.isFinite(n) || n === 0) return "";
    const f = this.$options.filters?.numFormat;
    return f ? f(n, "0,0.00") : n.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  dayMetric(map: any, date: string, field: string) {
    if (!map || !map[date]) return undefined;
    return map[date][field];
  }

  formatDayMetric(map: any, date: string, field: string) {
    return this.formatKgsHideZero(this.dayMetric(map, date, field));
  }

  slotQuantityField(slot: any) {
    return `slot:${slot.key}`;
  }

  daySlotQuantity(map: any, date: string, slot: any) {
    if (!map || !map[date]) return undefined;
    return map[date].slot_values?.[slot.key]?.quantity;
  }

  formatDaySlot(map: any, date: string, slot: any) {
    return this.formatKgsHideZero(this.daySlotQuantity(map, date, slot));
  }

  dayColClass(day: any, idx: number) {
    const classes = [idx % 2 === 0 ? "col-odd" : "col-even"];
    if (this.isAnchorDay(day)) {
      classes.push("is-anchor-day");
    }
    return classes;
  }

  metricCellClass(map: any, date: string, field: string, day: any, dayIdx: number) {
    const classes = [...this.dayColClass(day, dayIdx)];
    const value = field.startsWith("slot:")
      ? this.daySlotQuantity(map, date, { key: field.slice(5) })
      : this.dayMetric(map, date, field);
    if (Number.isFinite(Number(value)) && Number(value) < 0) {
      classes.push("is-negative");
    }
    return classes;
  }

  outputValue(row: any, date: string, slot: any) {
    const dayData = row.days && row.days[date] ? row.days[date] : null;
    const slotValues = dayData && dayData.slot_values ? dayData.slot_values : null;
    const slotData = slotValues && slotValues[slot.key] ? slotValues[slot.key] : null;
    return slotData && slotData.quantity != null ? slotData.quantity : "";
  }

  isOutputPending(date: string, productContainerId: any, slot: any) {
    return !!this.pendingOutputs[`${date}:${productContainerId}:${slot.key}`];
  }

  saveOutputs() {
    this.$store
      .dispatch(`${STORE_KEY}/savePendingOutputs`)
      .then(() => {
        this.$buefy.toast.open({ message: "Выпуск сохранён", type: "is-success" });
      })
      .catch((e: any) => this.showError(e));
  }

  productLabel(row: any) {
    return `${row.product_name || ""} ${row.product_container_name || ""}`.trim();
  }

  onOutputInput(sticker: any, row: any, date: string, slot: any, value: any) {
    const quantity = value === "" || value == null ? 0 : Number(value);
    this.$store.dispatch(`${STORE_KEY}/stageOutputCell`, {
      stickerId: sticker.sticker_id,
      productContainerId: row.product_container_id,
      date,
      slot,
      quantity
    });
  }

  showError(error: any) {
    this.$buefy.toast.open({
      message: error?.message || "Ошибка",
      type: "is-danger"
    });
  }
}
